// Starting up Alpine 
import Alpine from "alpinejs"
import focus from '@alpinejs/focus'
import ui from '@alpinejs/ui'
import persist from '@alpinejs/persist'

window.Alpine = Alpine
Alpine.plugin(focus)
Alpine.plugin(ui)
Alpine.plugin(persist)
Alpine.start();

require("console-polyfill");
require("jquery-match-height");
